var _g, _g2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAlmaz = function SvgAlmaz(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 130,
    height: 130,
    fill: "none",
    viewBox: "0 0 154 154"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#almaz_svg__filter0_d_3147_10957)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#FFEB62",
    strokeWidth: 6,
    d: "M139 77c0 34.242-27.758 62-62 62-34.241 0-62-27.758-62-62S42.76 15 77 15s62 27.758 62 62Z",
    shapeRendering: "crispEdges"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#almaz_svg__a)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 76.902,
    cy: 76.281,
    r: 62,
    stroke: "#7DE0FD",
    strokeWidth: 6,
    shapeRendering: "crispEdges"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#7DE0FD",
    d: "M37 52.896 64.822 38l16.641 2.352 19.762 10.192 11.961 13.85 3.38 32.143L56.761 113z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#BEEFFE",
    d: "m76.55 53.076-11.7-14.373 16.708 2.312 19.244 10.101 11.388 13.966-16.138-.77z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#85C4FF",
    d: "M37.657 53.448 64.74 38.496l11.825 14.952-19.455 22.62z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#44BFFB",
    d: "m91.058 90.252 6.104-24.92h15.64l3.433 31.437z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#1B93E9",
    d: "m55.728 75.847 1.247 36.995-19.702-60.158z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#7C67FF",
    d: "m57.492 112.87 33.95-23.386L117 96.385z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M57.558 75.433 37.827 53.027l16.656 22.406 2.387 35.841.688-33.266 29.138 12.76-29.138 21.749L90.1 92.172l26.248 3.949-24.967-7.04z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M77.546 52.51 65.503 39.632l9.993 12.876-14.57 18.946 16.62-16.628 17.681 11.59-2.562 17.511 5.125-17.512 14.921-1.231-16.459-1.602z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "almaz_svg__a",
    width: 152.034,
    height: 152.034,
    x: 0.885,
    y: 0.264,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.508
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.84 0 0 0 0 0.876857 0 0 0 0 0.9 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3147_10965"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_3147_10965",
    result: "shape"
  })))));
};
export default SvgAlmaz;